// angular dependency
import { CommonModule } from '@angular/common';
import { Component, input, output, signal } from '@angular/core';
import { MatCard, MatCardContent } from '@angular/material/card';

// third-party dependency

// fantasy dependency
import { GameHistoryUiHistoryListTableModule } from '@fantaz/game-history/ui/history-list-table';
import { IPageModel } from '@fantaz/shared/data-access/models';
import { SkeletonModule } from '@fantaz/shared/ui/skeleton';
import { userGameHistoryQuery } from '@fantaz/tournaments/data-access';

@Component({
  selector: 'fz-my-history-tab',
  standalone: true,
  imports: [
    CommonModule,
    GameHistoryUiHistoryListTableModule,
    MatCard,
    MatCardContent,
    SkeletonModule,
  ],
  templateUrl: './my-history-tab.component.html',
  styleUrl: './my-history-tab.component.scss',
})
export class MyHistoryTabComponent {
  /**
   * The unique identifier for the event prototype.
   * This value is required and must be a string.
   */
  eventPrototypeUuid = input.required<string>();

  /**
   * Event emitter that emits when the user tries for free.
   * This event does not carry any payload.
   */
  tryForFree = output<void>();

  /**
   * A signal representing the current page number.
   *
   * @type {number}
   */
  page = signal<number>(0);

  /**
   * A signal that holds the limit value for the component.
   *
   * @type {number}
   * @default 10
   */
  limit = signal<number>(10);

  query = userGameHistoryQuery({
    eventPrototypeUuid: this.eventPrototypeUuid,
    page: this.page,
    limit: this.limit,
    forfeited: true,
    gameType: 'CASUAL',
    orderBy: 'createdAt',
    orderDir: 'DESC',
  });

  onGameHistoryPageChange(page: IPageModel) {
    this.page.set(page.pageIndex);
    this.limit.set(page.pageSize);
  }

  handleTryForFree() {
    this.tryForFree.emit();
  }
}
